
export class ServerInterface {
  static get serverUrl(): string {
    const useLocalhost = window.location.search.toLowerCase().indexOf("uselocalhost") >= 0;
    /*if (useLocalhost) {
      return "http://localhost:8089";
    } else {
      return "https://tcgw-mv.hidora.com";
    }*/
   return "https://tcgw-mv.hidora.com";
  }

  ////////////////////////////////////////////////////////////////////////////////////////
  // helper functions
  ////////////////////////////////////////////////////////////////////////////////////////
  private static async postBookingToEndpoint(endPoint: string, bookingInfo: any): Promise<string | undefined> {
    try {
      const response = await fetch(ServerInterface.serverUrl + endPoint, {
        method: "POST",
        body: JSON.stringify(bookingInfo),
        headers: {
          Accept: "text/text",
          "Content-Type": "application/json",
        },
      });

      if (response.status == 200) {
        const msg = await response.text();
        // if (msg.substr(0, 3) == "@ok") {
        if (msg == "@ok") {
          return undefined;
        } else {
          return msg;
        }
      } else {
        return "@system error: " + response.status;
      }
    } catch (ex) {
      console.error(ex);
      return (ex as any).message;
    }
  }

  ////////////////////////////////////////////////////////////////////////////////////////
  // public functions
  ////////////////////////////////////////////////////////////////////////////////////////

  static async book(bookingInfo: any): Promise<string | undefined> {
    bookingInfo.dateCreated = new Date();
    return await ServerInterface.postBookingToEndpoint("/booking/book", bookingInfo);
  }

  static async checkBookingAllowed(bookingInfo: any): Promise<string | undefined> {
    bookingInfo.dateCreated = new Date();
    return await ServerInterface.postBookingToEndpoint("/booking/checkBookingAllowed", bookingInfo);
  }

  static async moveBooking(bookingInfo: any): Promise<string | undefined> {
    return await ServerInterface.postBookingToEndpoint("/booking/moveBooking", bookingInfo);
  }

  static async deleteBooking(bookingInfo: any): Promise<string | undefined> {
    return await ServerInterface.postBookingToEndpoint("/booking/delete", bookingInfo);
  }

  static async deleteBookingSerie(bookingInfo: any): Promise<string | undefined> {
    return await ServerInterface.postBookingToEndpoint("/booking/deleteSerie", bookingInfo);
  }

  //////////////////////////////////////////////////////////////////////////////////////

  static async checkKreuzbergMode(): Promise<boolean> {
    try {
      const response = await fetch(ServerInterface.serverUrl + "/booking/checkKreuzbergMode");
      const data = await response.text();

      return data == "@ok";
    } catch (ex) {
      console.error(ex);
    }

    return false;
  }

  static async loadMemberList(): Promise<Array<string>> {
    try {
      const response = await fetch(ServerInterface.serverUrl + "/booking/memberlist");
      const data = await response.text();
      return data.split("\n");
    } catch (ex) {
      console.error(ex);
    }

    return [];
  }

  static async loadFaqs(): Promise<string> {
    try {
      const response = await fetch(ServerInterface.serverUrl + "/Platzbelegung/faq.md");
      const data = await response.text();
      return data;
    } catch (ex) {
      console.error(ex);
    }

    return "";
  }

  static async getOpeningDate(): Promise<string> {
    try {
      const response = await fetch(ServerInterface.serverUrl + "/booking/opening");
      const data = await response.text();
      return data;
    } catch (ex) {
      console.error(ex);
    }

    return "";
  }
  

  static async register(registerInfo: any): Promise<any | undefined> {
    try {
      const response = await fetch(ServerInterface.serverUrl + "/booking/doregister", {
        method: "POST",
        body: JSON.stringify(registerInfo),
        headers: {
          "Content-type": "application/json; charset=UTF-8",
        },
      });

      const res = await response.json();
      return res;
    } catch (ex: any) {
      console.error(ex);
      return {
        error: ex.message
      }
    }

    return undefined;
  }

  static async getbookings(queryData: any): Promise<Array<any> | undefined> {
    try {
      const response = await fetch(ServerInterface.serverUrl + "/booking/getbookings", {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        method: "POST",
        body: JSON.stringify(queryData),
      });

      const multiDayBookings = await response.json();
      return multiDayBookings;
    } catch (ex) {
      console.error(ex);
    }

    return [];
  }

  static async makeBookingPublic(memberId: string, p: boolean): Promise<boolean> {
    try {
      const response = await fetch(ServerInterface.serverUrl + `/booking/setpublicbooking?id=${memberId}&value={p? "true" ? "false"}`);
    } catch (ex) {
      console.error(ex);
    }

    return true;
  }

  static async getIban(memberId: string): Promise<any | undefined> {
    try {
      const response = await fetch(ServerInterface.serverUrl + `/booking/getIBAN?id=${memberId}`);
      return await response.json();
    } catch (ex) {
      console.error(ex);
    }

    return undefined;
  }

  static async getMyNextBooking(memberId: string): Promise<any> {
    try {
      const response = await fetch(ServerInterface.serverUrl + `/booking/getMyNextBooking?id=${memberId}`);
      const s = await response.text();
      if (s) {
        return JSON.parse(s);
      } else {
        return undefined;
      }
    } catch (ex) {
      console.error(ex);
    }

    return undefined;
  }

  static async getHotNews(): Promise<string | undefined> {
    try {
      const response = await fetch(ServerInterface.serverUrl + `/booking/hotnews`);
      return await response.text();
    } catch (ex) {
      console.error(ex);
    }

    return undefined;
  }

  static async getFixedNews(): Promise<string | undefined> {
    try {
      const response = await fetch(ServerInterface.serverUrl + `/booking/fixednews`);
      return await response.text();
    } catch (ex) {
      console.error(ex);
    }

    return undefined;
  }

  static async requestPinBrief(email: string) {
    try {
      // https://tcgw-mv.hidora.com/members/sendRechnungen?id=1323&type=PinBrief
      const response = await fetch(ServerInterface.serverUrl + `/booking/sendPinbrief?email=${encodeURIComponent(email)}`);
      if (response.status == 200) {
        const msg = await response.text();
        if (msg.substr(0, 3) == "@ok") {
          return undefined;
        } else {
          return msg;
        }
      } else {
        return "@system error: " + response.status;
      }
    } catch (ex: any) {
      console.error(ex);
      return ex.message;
    }

    return "@error";
  }

  static async checkIfUrlExists(url: string): Promise<boolean> {
    try {
      // const response = await fetch(url, {
      //   mode: "no-cors",
      // });
      // return response.status == 200;

      const response = await fetch(ServerInterface.serverUrl + `/booking/checkIfUrlExists?url=${encodeURIComponent(url)}`);
      return (await response.text()) == "ok";
    } catch (ex) {
      console.error(ex);
    }

    return false;
  }

  static async saveProfileImage(data: any): Promise<boolean> {
    try {
      const response = await fetch(ServerInterface.serverUrl + "/booking/profileImage", {
        method: "POST",
        body: JSON.stringify(data),
        headers: {
          Accept: "text/text",
          "Content-Type": "application/json",
        },
      });

      const res = (await response.text()) == "ok";
      return res;
    } catch (ex) {
      console.error(ex);
    }
    return false;
  }


  static async getAllNewsletters(): Promise<Array<string> | undefined> {
    try {
      const s = await ServerInterface.postBookingToEndpoint("/newsletter/getAllNewsletters", {});
      if (s && s !== "{}") {
        return JSON.parse(s).names || [];
      } else {
        return undefined;
      }
    } catch {
      return undefined;
    }
  }



  static async getUnreadLastNewsletter(data: any): Promise<any | undefined> {
    try {
      const s = await ServerInterface.postBookingToEndpoint("/newsletter/unreadLastNewsletter", data);
      if (s && s !== "{}") {
        return JSON.parse(s);
      } else {
        return undefined;
      }
    } catch {
      return undefined;
    }
  }

}
